import {
  Form,
  Input,
  Row,
  Col,
  Select,
  Button,
  useSelect,
  Collapse,
  Typography,
  useForm,
  Icons,
  useModalForm,
  Create,
  Descriptions,
} from '@pankod/refine-antd'
import { IResourceComponentsProps, useCreateMany, useGetIdentity, useList, useTable } from '@pankod/refine-core'
import { PlusOutlined } from '@ant-design/icons'
import {
  IProduct,
  ITestTrack,
  ISection,
  ITopic,
  ITheme,
  ISubTheme,
  ISubject,
  IPaperTemplate,
  IPaperTemplateSubSection,
  IQuestionType,
} from 'interfaces'
import { useEffect, useState } from 'react'
import metaData from 'metadata/paperTemplateSubSections'
import { v4 as uuidv4 } from 'uuid'
import { CloneUpdateSubSection } from './clone_update_sub_section'
import { getLastCreatedPaperTemplate } from 'gql/mutations'
import { getSubSectionByTestTrack, getSubThemeBySubjects, getThemeDataBySubjects, getTopicBySubjects, getReportThemeDataBySubjects } from 'gql/query'

const { Text } = Typography
const { Panel } = Collapse

interface Params {
  [key: string]: string
}

type AllQuestions = {
  question_count: number
  section_id: string
  total_mark: number
  index: any
  currentMark: number
}
type Details = {
  subject_id: any
  report_theme_id: any
  theme_id: any
  subtheme_id: any
  topic_id: any
  index: string
}
type SectionDetails = {
  section_name: string
  section_id: string
  data: Details[]
}
type SectionTotal = {
  question_count: number
  section_id: string
  total_mark: number
}
export const ClonePaperTemplate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, queryResult } = useForm<IPaperTemplate>({
    metaData: {
      fields: [
        'id',
        'name',
        'product_id',
        'sections',
        'description',
        { product: ['name', 'id', 'sections'] },
        'test_track_id',
        { test_tracks: ['name'] },
        'created_at',
      ],
    },
    redirect: 'list',
    queryOptions: { staleTime: Infinity },
  })
  var section_arr: object[] = []
  const { mutate } = useCreateMany<IPaperTemplateSubSection>()

  const [form] = Form.useForm<IPaperTemplate>()
  let record = queryResult?.data?.data
  const { data: user } = useGetIdentity()
  const [showTestTrack, setShowTestTrack] = useState(false)
  const [showSubSection, setShowSubSection] = useState(false)
  const [formValues, setFormValues] = useState([{ id: '', value: 0 }])
  const [removedIds, setRemovedIds] = useState<object[]>([])
  const [showSubjectData, setShowSubjectData] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [currentSectionId, setCurrentSectionId] = useState<string>('')
  const [sectionList, setSectionList] = useState<IPaperTemplate>()
  const [subSectionList, setSubSectionList] = useState<object[]>([])
  const [oldData, setOldData] = useState<object[]>([])
  const [allSubSectionData, setAllSubSectionData] = useState<object>({})
  const [selectedSubjects, setSelectedSubjects] = useState<SectionDetails[]>([])
  const [selectedThemes, setSelectedThemes] = useState<object[]>([])
  const [selectedSubThemes, setSelectedSubThemes] = useState<object[]>([])
  const [showSection, setShowSection] = useState(false)
  const [subSectionData, setSubSectionData] = useState([] as any[])
  const [showError, setError] = useState(false)
  const [loaded, setLoad] = useState(false)
  const [allQuestions, setAllQuestion] = useState<AllQuestions[]>([])
  const [sectionTotal, setSectionTotal] = useState<SectionTotal[]>([])
  const { tableQueryResult: sectionQueryResult, setFilters: sectionFilters } = useTable<ISection>({
    resource: 'sections',
    metaData: {
      fields: ['id', 'name'],
    },
  })
  // const { tableQueryResult: subSectionQueryResult, setFilters: subSectionFilters } = useTable<IPaperTemplateSubSection>({
  //   resource: 'paper_template_sub_sections',
  //   metaData,
  // })
  // const showModal = () => {
  //   setIsModalVisible(true)
  // }
  const [reportThemeList, setReportThemeList] = useState([] as any[])
  const [themeList, setThemeList] = useState([] as any[])
  const [subThemeList, setSubThemeList] = useState([] as any[])
  const [topicList, setTopicList] = useState([] as any[])

  const { setFilters: setTestTrackFilters, tableQueryResult: testTrackQueryResult } = useTable<ITestTrack>({
    resource: 'test_tracks',
    metaData: {
      fields: ['subject_ids', 'id', 'name'],
    },
    initialPageSize: 1000,
  })
  const { setFilters: setSubjectFilter, tableQueryResult: subjectkQueryResult } = useTable<ISubject>({
    resource: 'subjects',
    metaData: {
      fields: ['id', 'name'],
    },
    initialPageSize: 1000,
  })
  const {
    tableQueryResult: topicResult,
    filters: topicFilters,
    setFilters: setTopicFilters,
    sorter,
  } = useTable<ITopic>({
    resource: 'topics',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'sub_theme_id', { sub_theme: ['id'] }] },
    queryOptions: { enabled: false },
  })
  const {
    filters: themeFilters,
    setFilters: setThemeFilters,
    tableQueryResult: themeResult,
  } = useTable<ITheme>({
    resource: 'themes',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'subject_id'] },
    queryOptions: { enabled: false },
  })

  const {
    filters: subThemeFilters,
    setFilters: setSubThemeFilters,
    tableQueryResult: subThemeResult,
  } = useTable<ISubTheme>({
    resource: 'sub_themes',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'theme_id', { theme: ['id', 'subject_id'] }] },
    queryOptions: { enabled: false },
  })
  const [sectionListIds, setSectionListIds] = useState<string[]>([])
  const { filters, setFilters, tableQueryResult } = useTable({
    resource: 'products',
    initialPageSize: 1000,
    metaData: {
      fields: ['id', 'sections', 'name', 'test_track_ids', 'section_ids'],
    },
    queryOptions: { staleTime: Infinity },
  })
  const { tableQueryResult: questionTypeSelectProps } = useTable({
    resource: 'question_types',
    metaData: {
      fields: ['id', 'name'],
    },
    queryOptions: { staleTime: Infinity },
  })
  const { selectProps: testtrackSelectProps } = useSelect<ITestTrack>({
    resource: 'test_tracks',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 1000,
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: [
      {
        field: 'id',
        operator: 'in',
        value: tableQueryResult?.data?.data[0]?.test_track_ids ?? [],
      },
    ],
    queryOptions: { enabled: !!tableQueryResult?.data?.data[0]?.test_track_ids },
  })

  const handleProductChange = (value: { value: any }) => {
    setFilters([
      {
        field: 'id',
        operator: 'eq',
        value: value,
      },
    ])
    setShowTestTrack(true)
  }

  useEffect(() => {
    let arr = [...allQuestions]
    let section_tot = [...sectionTotal]
    let total_questions = 0
    let total_mark = 0
    queryResult?.data?.data?.product?.sections?.map((item: any) => {
      total_questions = 0
      total_mark = 0
      subSectionData?.map((data: any, i: any) => {
        if (!removedIds?.includes(data?.id)) {
          let foundSection = section_tot.findIndex((elem: any) => elem?.section_id === data?.section_id)
          if (item?.section_id === data?.section_id) {
            let found = arr.findIndex((elem: any) => elem?.index === data?.id)
            if (found === -1) {
              arr.push({
                section_id: data?.section_id,
                question_count: parseInt(data?.no_of_questions),
                total_mark: parseInt(data?.no_of_questions) * parseInt(data?.mark_per_question),
                index: data?.id,
                currentMark: parseInt(data?.mark_per_question),
              })
            } else {
              arr[found]['currentMark'] = parseInt(data?.mark_per_question)
              arr[found]['question_count'] = parseInt(data?.no_of_questions)
              arr[found]['total_mark'] = parseInt(data?.no_of_questions) * parseInt(data?.mark_per_question)
            }

            if (foundSection == -1) {
              total_questions = total_questions + parseInt(data?.no_of_questions)
              total_mark = total_mark + parseInt(data?.mark_per_question) * parseInt(data?.no_of_questions)
              section_tot.push({
                total_mark: total_mark,
                section_id: data?.section_id,
                question_count: total_questions,
              })
            } else {
              total_questions = total_questions + parseInt(data?.no_of_questions)
              total_mark = total_mark + parseInt(data?.mark_per_question) * parseInt(data?.no_of_questions)
              section_tot[foundSection]['question_count'] = total_questions
              section_tot[foundSection]['total_mark'] = total_mark
            }
          }
        }
      })
    })

    arr = arr.filter(
      (elem: any, index: any, self: any) =>
        self.findIndex((t: any) => {
          return t.section_id === elem.section_id && t.index === elem.index
        }) === index
    )
    section_tot = section_tot.filter(
      (elem: any, index: any, self: any) =>
        self.findIndex((t: any) => {
          return t.section_id === elem.section_id
        }) === index
    )
    setAllQuestion(arr)
    setSectionTotal(section_tot)
  }, [subSectionData])

  useEffect(() => {
    let break_stmt: boolean = false
    let i = 0
    queryResult?.data?.data?.product?.sections?.map((data: any) =>
      sectionTotal?.map((total: any) => {
        if (data?.section_id === total?.section_id) {
          if (break_stmt) {
            return
          }

          if (total?.question_count > parseInt(data?.no_of_questions)) {
            break_stmt = true

            return
          } else if (total?.total_mark > parseInt(data?.marks)) {
            break_stmt = true

            return
          } else if (total?.question_count <= parseInt(data?.no_of_questions) && total?.total_mark <= parseInt(data?.marks)) {
            break_stmt = false
          }
        }
      })
    )
    setError(break_stmt)
    // console.log('out', break_stmt)
  }, [sectionTotal])
  console.log({ showError })
  const changeOldData = (value: any, id: string, key: string, section_id: string) => {
    let data_arr: object[] = [...oldData]
    let arr: any[] = [...subSectionData]
    let arr1: any[] = [...subSectionList]
    console.log('subSectionData', subSectionData, id, section_id)
    let found2 = arr1.findIndex((elem: any) => elem?.id === id)
    let found1 = arr.findIndex((elem: any) => elem?.id === id)
    let found = data_arr.findIndex((elem: any) => elem?.id === id)
    if (found1 !== -1) {
      arr[found1][key] = value
    }
    if (found2 !== -1) {
      arr1[found2][key] = value
    }
    if (found === -1) {
      let obj = { [key]: value, id: id }

      data_arr.push(obj)
    } else {
      let obj = { [key]: value }
      if (key !== '') {
        let params = data_arr[found]
        ;(params as Params)[key] = value
        data_arr[found] = params
      }
    }
    console.log('data_arr', data_arr)
    setSubSectionData(arr)
    setSubSectionList(arr1)
    setOldData(data_arr)
    // if (key === 'no_of_questions' || key === 'mark_per_question') {
    //   setTotalQuestion(section_id, value, key, id)
    // }
  }
  const handleOk = (values: any) => {
    let arr: object[] = [...subSectionData]

    let arr_details = [...allQuestions]
    let section_tot: SectionTotal[] = []
    console.log('xxxbefore,', { arr_details, section_tot })
    let total_questions = 0
    let total_mark = 0
    let newValues: IPaperTemplateSubSection = values

    newValues['section_id'] = currentSectionId

    let selected: SectionDetails[] = [...selectedSubjects]

    selected.map((item: SectionDetails, index: any) => {
      if (item?.section_id === currentSectionId) {
        let found = item?.data.findIndex((elem: Details) => elem?.index === values?.id)
        if (found === -1) {
          item?.data?.push({
            index: values?.id,
            subject_id: values?.subject_id,
            report_theme_id: values?.report_theme_id,
            theme_id: values?.theme_id,
            subtheme_id: values?.sub_theme_id,
            topic_id: values?.topic_id,
          })
        }
      }
    })

    arr.push(newValues)

    // console.log('xxxFOund', { foundSection })
    arr_details.push({
      section_id: currentSectionId,
      question_count: parseInt(values?.no_of_questions),
      total_mark: parseInt(values?.no_of_questions) * parseInt(values?.mark_per_question),
      index: values?.id,
      currentMark: parseInt(values?.mark_per_question),
    })
    // arr_details.map((item: any) => {
    //   let foundSection = section_tot.findIndex((elem: any) => elem?.section_id === item?.section_id)
    //   if (foundSection === -1) {
    //     section_tot.push({
    //       total_mark: item?.total_mark,
    //       section_id: item?.section_id,
    //       question_count: item?.question_count,
    //     })
    //   } else {
    //     section_tot[foundSection].question_count = section_tot[foundSection].question_count + item?.question_count
    //     section_tot[foundSection].total_mark = section_tot[foundSection].total_mark + item?.total_mark
    //   }
    //   // if (item?.section_id === currentSectionId) {
    //   //   total_questions = total_questions + item?.question_count
    //   //   total_mark = total_mark + item?.total_mark
    //   // }
    // })
    console.log('xxxnewarr', { arr_details })

    // } else {
    //   console.log('xxxelse')
    //   // section_tot[foundSection]
    //   section_tot[foundSection].question_count = 0
    //   section_tot[foundSection].total_mark = 0
    //   section_tot[foundSection].question_count = total_questions
    //   section_tot[foundSection].total_mark = total_mark
    // }
    console.log('xxxnewsectiontot', { section_tot, total_questions, total_mark })
    setSubSectionData(arr)
    setCurrentSectionId('')
    createClose()
    setAllQuestion(arr_details)
    // setSectionTotal(section_tot)
    setSelectedSubjects(selected)
    changeTotalData(arr_details)
  }
  // const setTotalQuestion = async (section_id: string, value: any, type: string, index: any) => {
  //   let arr = [...allQuestions]
  //   // let section_tot: SectionTotal[] = []

  //   let found = arr.findIndex((elem: any) => elem?.section_id == section_id && elem?.index == index)
  //   // let foundSection = section_tot.findIndex((elem: any) => elem?.section_id === section_id)

  //   if (found === -1) {
  //     if (type === 'no_of_questions') {
  //       arr.push({
  //         section_id: section_id,
  //         question_count: parseInt(value),
  //         total_mark: 0,
  //         index: index,
  //         currentMark: 0,
  //       })
  //     } else {
  //       arr.push({
  //         section_id: section_id,
  //         question_count: 0,
  //         total_mark: parseInt(value),
  //         index: index,
  //         currentMark: parseInt(value),
  //       })
  //     }
  //   } else {
  //     let currentMark = arr[found]['currentMark']
  //     if (type === 'no_of_questions') {
  //       if (!isNaN(value)) {
  //         arr[found]['question_count'] = parseInt(value)
  //         arr[found]['total_mark'] = currentMark * parseInt(value)
  //       }
  //     } else {
  //       if (!isNaN(value)) {
  //         arr[found]['total_mark'] = arr[found]['question_count'] * parseInt(value)
  //         arr[found]['currentMark'] = parseInt(value)
  //       }
  //     }
  //   }
  //   arr = arr?.filter((elem: any) => !removedIds.includes(elem?.index))

  //   console.log('xxxxxxxxxxxxxxx ccc', { arr })
  //   // let total_question = 0,
  //   //   total_mark = 0

  //   // console.log({ fields })

  //   // sectionQueryResult?.data?.data?.map((item: any, index: any) => {
  //   //     let section_name = item?.name.toLowerCase().replaceAll(' ', '_')
  //   //     const fields = formProps?.form?.getFieldsValue()
  //   //     const section = fields?.previous_data
  //   //   if (section !== undefined) {
  //   //     section?.map((data: any) => {
  //   //       if (data?.section_id === section_id) {
  //   //         total_question = total_question + parseInt(data?.no_of_questions)
  //   //         total_mark = total_mark + parseInt(data?.mark_per_question) * parseInt(data?.no_of_questions)
  //   //       }
  //   //     })
  //   //     let foundSection = section_tot.findIndex((elem: any) => elem?.section_id === section_id)
  //   //     if (foundSection === -1) {
  //   //       section_tot.push({
  //   //         section_id: section_id,
  //   //         total_mark: !isNaN(total_mark) ? total_mark : 0,
  //   //         question_count: !isNaN(total_question) ? total_question : 0,
  //   //       })
  //   //     } else {
  //   //       section_tot[foundSection]['total_mark'] = !isNaN(total_mark) ? total_mark : 0
  //   //       section_tot[foundSection]['question_count'] = !isNaN(total_question) ? total_question : 0
  //   //     }
  //   //   }
  //   // })
  //   // console.log('xxxxxxxxxxxxxxx', { section_id, section_tot })
  //   setAllQuestion(arr)
  //   changeTotalData(arr)
  //   // setSectionTotal(section_tot)
  // }

  useEffect(() => {
    getSubSectionByTestTrack(queryResult?.data?.data?.id).then((resp: any) => {
      setSubSectionData(resp?.paper_template_sub_sections)
      setLoad(true)
    })
  }, [queryResult?.data?.data])
  useEffect(() => {
    setFilters([
      {
        field: 'id',
        operator: 'eq',
        value: queryResult?.data?.data?.product_id,
      },
    ])
    // setSectionList(record)
    setShowTestTrack(true)
  }, [queryResult?.data?.data])
  useEffect(() => {
    let arr: string[] = []
    record?.sections?.map((item: any) => {
      if (!arr.includes(item)) arr.push(item)
    })

    sectionFilters([
      {
        field: 'id',
        operator: 'in',
        value: arr,
      },
    ])
    setShowSubSection(true)
    setSectionListIds(arr)
  }, [queryResult?.data?.data])

  //   const testTrackResult = useMany<ITestTrack>({
  //     resource: 'test_tracks',
  //     ids: tableQueryResult?.data?.data[0]?.test_track_ids ?? [],
  //     metaData: {
  //       fields: ['id', 'name', 'grade_ids', 'subject_ids'],
  //     },
  //   })

  // const subjectQueryResult = useList<ISubject>({
  //   resource: 'subjects',
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   config: {
  //     pagination: { pageSize: 1000 },
  //   },
  // })
  const handleTestTrackChange = (value: { value: any }) => {
    setTestTrackFilters([
      {
        field: 'id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  useEffect(() => {
    setTestTrackFilters([
      {
        field: 'id',
        operator: 'eq',
        value: record?.test_track_id,
      },
    ])
  }, [queryResult?.data?.data])

  useEffect(() => {
    setSectionList(record)
  }, [record])

  const handleSubjectChange = (
    value: { value: any },
    type: string,
    id: any,
    name: string,
    key: any,
    keyword: any,
    section_name: string,
    section_id: string
  ) => {
    // let arr: object[] = []
    // reporTh.pop()
    let arr: SectionDetails[] = [...selectedSubjects]

    arr.map((item: SectionDetails, index: any) => {
      if (item?.data?.length > 0) {
        // if()
        item?.data?.map((details: Details) => {
          if (details?.index === id) {
            details['subject_id'] = value
            // details['section']
          }
        })
      } else {
        item?.data?.push({
          index: id,
          subject_id: value,
          report_theme_id: '',
          theme_id: '',
          subtheme_id: '',
          topic_id: '',
        })
      }
    })
    const fields = formProps?.form?.getFieldsValue()
    if (fields !== undefined && fields.hasOwnProperty(name)) {
      let result = Object.fromEntries(Object.entries(fields).map(([key, value]) => [key, value]))
      let { previous_data } = result
      let theme_id = keyword + '_theme_id'
      let sub_theme_id = keyword + '_sub_theme_id'
      let topic_id = keyword + '_topic_id'
      let obj = {
        [theme_id]: null,
        [sub_theme_id]: null,
        [topic_id]: null,
      }
      // Object.assign(result, obj)
      formProps?.form?.setFieldsValue({
        [name]: obj,
      })
    }
    setThemeFilters([
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ])
    if (type === 'edit') {
      changeOldData(value, id, 'subject_id', section_id)
    }
    // setSelectedSubjects(arr)
  }
  const handleReportThemeChange = (
    value: { value: any },
    type: string,
    id: string,
    name: string,
    key: any,
    section_name: any,
    section: any,
    section_id: string
  ) => {
    // subThemeFilters.pop()
    let arr: SectionDetails[] = [...selectedSubjects]

    arr.map((item: any, index: any) => {
      item?.data?.map((details: Details) => {
        if (details?.index === id) {
          details['report_theme_id'] = value
        }
      })
    })

    const fields = formProps?.form?.getFieldsValue()
    if (fields !== undefined && fields.hasOwnProperty(name)) {
      let result = Object.fromEntries(Object.entries(fields).map(([key, value]) => [key, value]))
      let theme_id = section_name + '_theme_id'
      let sub_theme_id = section_name + '_sub_theme_id'
      let topic_id = section_name + '_topic_id'
      let obj = {
        [sub_theme_id]: null,
        [topic_id]: null,
        [theme_id]: null,
      }
      // Object.assign(result, obj)
      formProps?.form?.setFieldsValue({
        [name]: obj,
      })
    }
    setThemeFilters([
      {
        field: 'report_theme_id',
        operator: 'eq',
        value: value,
      },
    ])

    if (type === 'edit') {
      changeOldData(value, id, 'report_theme_id', section_id)
    }
    setSelectedThemes(arr)
  }
  const handleThemeChange = (
    value: { value: any },
    type: string,
    id: string,
    name: string,
    key: any,
    section_name: any,
    section: any,
    section_id: string
  ) => {
    // subThemeFilters.pop()
    let arr: SectionDetails[] = [...selectedSubjects]

    arr.map((item: any, index: any) => {
      item?.data?.map((details: Details) => {
        if (details?.index === id) {
          details['theme_id'] = value
        }
      })
    })
    const fields = formProps?.form?.getFieldsValue()
    if (fields !== undefined && fields.hasOwnProperty(name)) {
      let result = Object.fromEntries(Object.entries(fields).map(([key, value]) => [key, value]))
      let sub_theme_id = section_name + '_sub_theme_id'
      let topic_id = section_name + '_topic_id'
      let obj = {
        [sub_theme_id]: null,
        [topic_id]: null,
      }
      // Object.assign(result, obj)
      formProps?.form?.setFieldsValue({
        [name]: obj,
      })
    }
    setSubThemeFilters([
      {
        field: 'theme_id',
        operator: 'eq',
        value: value,
      },
    ])

    if (type === 'edit') {
      changeOldData(value, id, 'theme_id', section_id)
    }
    setSelectedThemes(arr)
  }
  const handleSubThemeChange = (value: { value: any }, type: string, id: string, name: string, key: any, keyword: any, section: string) => {
    let arr: SectionDetails[] = [...selectedSubjects]
    arr.map((item: any, index: any) => {
      item?.data?.map((details: Details) => {
        if (details?.index === id) {
          details['subtheme_id'] = value
        }
      })
    })
    const fields = formProps?.form?.getFieldsValue()
    if (fields !== undefined && fields.hasOwnProperty(name)) {
      let result = Object.fromEntries(Object.entries(fields).map(([key, value]) => [key, value]))
      let topic_id = keyword + '_topic_id'
      let obj = {
        [topic_id]: null,
      }
      // Object.assign(result, obj)
      formProps?.form?.setFieldsValue({
        [name]: obj,
      })
    }
    setTopicFilters([
      {
        field: 'sub_theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }

  const { selectProps: productSelectProps } = useSelect<IProduct>({
    resource: 'products',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 1000,
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    // queryOptions: { staleTime: Infinity },
  })

  const addSubsection = (id: string) => {
    setCurrentSectionId(id)
    createShow()
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }

  useEffect(() => {
    let newFormValues = [...formValues]

    if (JSON.stringify(record?.sections) !== '{}') {
      record?.sections?.map((item: any) => {
        newFormValues.push({
          id: item?.section_id,
          value: item?.sub_section_details?.length,
        })
        setFormValues(newFormValues)
      })
    }
  }, [queryResult?.data?.data])

  const removeData = (id: any) => {
    let arr: object[] = [...removedIds]
    // let new_arr: AllQuestions[] = []
    let arr_qstn = [...allQuestions]
    arr.push(id)
    arr = arr.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) == index
    })
    arr_qstn = arr_qstn?.filter((elem: any) => !arr.includes(elem?.index))
    console.log('xxxxxxxxxxxxxxxxxxxxx', { arr_qstn })
    setRemovedIds(arr)
    setAllQuestion(arr_qstn)
    changeTotalData(arr_qstn)
  }
  const changeTotalData = (arr: any) => {
    let total_question = 0,
      total_mark = 0
    let section_tot: SectionTotal[] = []

    arr.map((item: any, index: any) => {
      if (!removedIds.includes(item?.index)) {
        let foundSection = section_tot.findIndex((o: any) => o.section_id === item.section_id)
        if (foundSection === -1) {
          section_tot.push({
            total_mark: item?.total_mark,
            section_id: item?.section_id,
            question_count: item?.question_count,
          })
        } else {
          section_tot[foundSection].question_count += item?.question_count
          section_tot[foundSection].total_mark += item?.total_mark
        }
      }
    })

    // let section_tot: SectionTotal[] = []
    // console.log('xxxxxxxxxxxxxxxarr', { arr })
    // let totals: any = []
    // arr.forEach((x: any) => {
    //   let foundSection = section_tot.findIndex((o: any) => o.section_id === x.section_id)
    //   // console.log('xxxxxxxxxxxxxxxx', { x })
    //   if (foundSection === -1) {
    //     section_tot.push({
    //       total_mark: x?.total_mark,
    //       section_id: x?.section_id,
    //       question_count: x?.question_count,
    //     })
    //   } else {
    //     section_tot[foundSection].question_count += x?.question_count
    //     section_tot[foundSection].total_mark += x?.total_mark
    //     console.log('xxxxxxxxxxxxxxxxcount', section_tot[foundSection],x)
    //   }
    // })

    // console.log({ section_tot })

    // arr.map((item: any) => {
    //   let foundSection = section_tot.findIndex((elem: any) => elem?.section_id === item?.section_id)
    //   if (foundSection === -1) {
    //     section_tot.push({
    //       total_mark: item?.total_mark,
    //       section_id: item?.section_id,
    //       question_count: item?.question_count,
    //     })
    //   }
    //   else {
    //     console.log('xxxxxxxxxxxxxxx', { foundSection, item, section_tot })
    //     section_tot[foundSection].question_count = section_tot[foundSection].question_count + parseInt(item?.question_count)
    //     section_tot[foundSection].total_mark = section_tot[foundSection].total_mark + parseInt(item?.total_mark)
    //   }
    //
    // })
    console.log('xxxxxxxxxxxxxxx after', { section_tot })
    setSectionTotal(section_tot)
  }

  useEffect(() => {
    if (record?.test_track_id !== '' && record?.test_track_id !== null && record?.test_track_id !== undefined) {
      setSubjectFilter([
        {
          field: 'id',
          operator: 'in',
          value: testTrackQueryResult?.data?.data[0]?.subject_ids ?? [],
        },
      ])
      if (testTrackQueryResult?.data?.data[0]?.subject_ids !== null) {
        getReportThemeDataBySubjects(JSON.stringify(testTrackQueryResult?.data?.data[0]?.subject_ids)).then((resp: any) => {
          console.log('resp', resp)
          setReportThemeList(resp?.report_themes)
        })
        getThemeDataBySubjects(JSON.stringify(testTrackQueryResult?.data?.data[0]?.subject_ids)).then((resp: any) => {
          setThemeList(resp?.themes)
        })
        getSubThemeBySubjects(JSON.stringify(testTrackQueryResult?.data?.data[0]?.subject_ids)).then((resp: any) => {
          setSubThemeList(resp?.sub_themes)
        })
        getTopicBySubjects(JSON.stringify(testTrackQueryResult?.data?.data[0]?.subject_ids)).then((resp: any) => {
          setTopicList(resp?.topics)
        })
        setShowSubjectData(true)
      }
    } else {
      setShowSubjectData(false)
    }
  }, [testTrackQueryResult?.data?.data])

  useEffect(() => {
    // sectionQueryResult?.data?.data?.map((item: any) => {
    let arr: Details[] = []
    let selected: SectionDetails[] = [...selectedSubjects]
    sectionQueryResult?.data?.data?.map((item: any) => {
      if (JSON.stringify(subSectionData) !== '{}') {
        subSectionData?.map((section: any, i: any) => {
          if (item?.id === section?.section_id) {
            var found = selected.findIndex(function (element: any) {
              return element?.section_id === item?.id
            })

            if (found !== -1) {
              var foundDetails = selected[found]?.data?.findIndex(function (element: any) {
                return element?.index === i
              })
              if (foundDetails === -1) {
                selected[found]?.data?.push({
                  index: section?.id,
                  subject_id: section?.subject_id,
                  report_theme_id: section?.report_theme_id,
                  theme_id: section?.theme_id,
                  subtheme_id: section?.sub_theme_id,
                  topic_id: section?.topic_id,
                })
              }
            } else {
              arr.push({
                index: section?.id,
                subject_id: section?.subject_id,
                report_theme_id: section?.report_theme_id,
                theme_id: section?.theme_id,
                subtheme_id: section?.sub_theme_id,
                topic_id: section?.topic_id,
              })
              selected.push({
                section_name: item?.name.toLowerCase().replaceAll(' ', '_'),
                section_id: item?.id,
                data: arr,
              })
            }
          } else {
            var indexFound = selected.findIndex(function (element: any) {
              return element?.section_id === item?.id
            })
            if (indexFound === -1) {
              selected.push({
                section_name: item?.name.toLowerCase().replaceAll(' ', '_'),
                section_id: item?.id,
                data: [],
              })
            }
          }
        })
      }
    })

    // if (JSON.stringify(subjectkQueryResult?.data?.data) !== '{}') {
    //   if (JSON.stringify(subSectionData) !== '{}') {
    //     subSectionData?.map((section: any, i: any) => {
    //       console.log('section', section)
    //       // subjectkQueryResult?.data?.data?.map((item: any, index: any) => {
    //       //   if (section.subject_id === item?.id) {
    //       //     arr.push({
    //       //       index: section?.id,
    //       //       subject_id: item?.id,
    //       //       section_name: section?.section?.name.toLowerCase().replaceAll(' ', '_'),
    //       //     })
    //       //   }
    //       // })
    //     })
    //   }
    // }
    arr = arr.filter(
      (elem: any, index: any, self: any) =>
        self.findIndex((t: any) => {
          return t.index === elem.index
        }) === index
    )

    setSelectedSubjects(selected)
    // setSelectedThemes(theme)
    // setSelectedSubThemes(subtheme)
  }, [subSectionData, sectionQueryResult?.data?.data])
  console.log('subSectionData', selectedSubjects)
  const addCloneData = (data: any) => {}

  const onFinish = async (values: any) => {
    let arr: object[] = []
    sectionQueryResult?.data?.data?.map((item: any) => {
      if (JSON.stringify(values?.previous_data) !== '{}') {
        subSectionData?.map((subsection: any, index: any) => {
          if (subsection?.section_id === item?.id && !removedIds.includes(subsection?.id)) {
            console.log('subsectionxxxx', subsection)
            section_arr.push({
              name: subsection?.name,
              section_id: item?.id,
              // paper_template_id: paper_template_id,
              subject_id: subsection?.subject_id,
              report_theme_id: subsection?.report_theme_id,
              theme_id: subsection?.theme_id,
              sub_theme_id: subsection?.sub_theme_id,
              topic_id: subsection?.topic_id,
              no_of_questions: subsection?.no_of_questions,
              mark_per_question: subsection?.mark_per_question,
              question_type_id: subsection?.question_type_id,
            })
          }
        })
      }
      // if (JSON.stringify(values?.new_data) !== '{}') {
      //   if (subSectionList.length > 0) {
      //     subSectionList?.map((elem: any, i: any) => {
      //       if (elem?.section_id === item?.id && !removedIds.includes(elem?.id)) {
      //         section_arr.push({
      //           name: elem?.name,
      //           section_id: item?.id,
      //           // paper_template_id: paper_template_id,
      //           subject_id: elem?.subject_id,
      //           report_theme_id: elem?.report_theme_id,
      //           theme_id: elem?.theme_id,
      //           sub_theme_id: elem?.sub_theme_id,
      //           topic_id: elem?.topic_id,
      //           no_of_questions: elem?.no_of_questions,
      //           mark_per_question: elem?.mark_per_question,
      //           question_type_id: elem?.question_type_id,
      //         })
      //       }
      //     })
      //   }
      // }
    })

    let break_stmt: number = -1
    console.log('break_stmt', tableQueryResult?.data?.data[0]?.sections?.length, sectionTotal.length)
    if (tableQueryResult?.data?.data[0]?.sections?.length !== sectionTotal.length) {
      break_stmt = 0
    } else {
      tableQueryResult?.data?.data[0]?.sections?.map((data: any) =>
        sectionTotal?.map((total: any) => {
          if (data?.section_id === total?.section_id) {
            if (break_stmt == 0) {
              return
            }

            if (total?.question_count == parseInt(data?.no_of_questions) && total?.total_mark == parseInt(data?.marks)) {
              break_stmt = 1
            } else {
              break_stmt = 0
              return
            }
          }
        })
      )
    }

    return (
      formProps.onFinish &&
      formProps.onFinish({
        name: values?.name,
        description: values?.description,
        product_id: values?.product_id,
        status: '',
        created_by: user?.id,
        sections: sectionListIds,
        test_track_id: values?.test_track_id,
        is_completed: break_stmt === 1 ? true : false,
      })
    )
  }

  const {
    formProps: createFormProps,
    modalProps: createModalProps,
    show: createShow,
    close: createClose,
  } = useModalForm({
    resource: 'paper_template_sub_sections',
    action: 'create',
    redirect: false,
    metaData,
  })
  const genExtra = () => <Button>Add All</Button>
  console.log('xxxxxxxxxxxxxxxxxxxxx', { sectionTotal })
  return (
    <Create saveButtonProps={{ disabled: showError, onClick: () => formProps?.form?.submit() }}>
      <Form
        size="large"
        {...formProps}
        layout="vertical"
        onFinish={values =>
          onFinish(values).then((values: any) => {
            let paper_template_id = ''
            formProps.form?.resetFields()
            getLastCreatedPaperTemplate().then((resp: any) => {
              paper_template_id = resp?.paper_templates[0]?.id
              section_arr.map((elem: any) => {
                elem['paper_template_id'] = paper_template_id
              })

              mutate({
                resource: 'paper_template_sub_sections',
                values: section_arr,
              })
            })
          })
        }
      >
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={8}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder="PaperTemplate Name" />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Product" name="product_id" rules={[{ required: true }]}>
              <Select {...productSelectProps} onChange={handleProductChange} disabled />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item
              label="Description"
              name="description"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input placeholder="Description" type="small" />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Test Track" name="test_track_id" rules={[{ required: true }]}>
              <Select {...testtrackSelectProps} onChange={handleTestTrackChange} disabled />
            </Form.Item>
          </Col>
          {/* {showTestTrack === true ? (
            <Col xs={24} lg={24} style={{ marginBottom: 15, marginTop: 15 }}>
              <Text strong>Test Tracks:</Text>
              {testTrackResult?.data?.data?.map(item => (
                <Text keyboard>{item.name}</Text>
              ))}
            </Col>
          ) : null} */}
        </Row>
        <Row>
          <Col xs={24} lg={24}>
            <h3>Paper Format</h3>
            {/* {rendePaperFormat()} */}

            <Collapse defaultActiveKey={sectionListIds} activeKey={sectionListIds}>
              {sectionQueryResult !== undefined &&
                sectionQueryResult !== null &&
                sectionQueryResult?.data?.data?.map((item: any) => (
                  <Panel header={item?.name} key={item?.id}>
                    <>
                      <Row gutter={[16, 0]} style={{ height: 40, background: '#f8f8fb', alignItems: 'center' }}>
                        <Col lg={2}>
                          <Typography.Text style={{ fontWeight: 600, fontSize: 14 }}>Name</Typography.Text>
                        </Col>
                        <Col lg={3}>
                          <Typography.Text style={{ fontWeight: 600, fontSize: 14 }}>Subject</Typography.Text>
                        </Col>
                        <Col lg={3}>
                          <Typography.Text style={{ fontWeight: 600, fontSize: 14 }}>Report Theme</Typography.Text>
                        </Col>
                        <Col lg={3}>
                          <Typography.Text style={{ fontWeight: 600, fontSize: 14 }}>Theme</Typography.Text>
                        </Col>
                        <Col lg={3}>
                          <Typography.Text style={{ fontWeight: 600, fontSize: 14 }}>Sub Theme</Typography.Text>
                        </Col>
                        <Col lg={3}>
                          <Typography.Text style={{ fontWeight: 600, fontSize: 14 }}>Topic</Typography.Text>
                        </Col>
                        <Col lg={2}>
                          <Typography.Text style={{ fontWeight: 600, fontSize: 14 }}>Type</Typography.Text>
                        </Col>
                        <Col lg={2}>
                          <Typography.Text style={{ fontWeight: 600, fontSize: 14 }}>No Of Questions</Typography.Text>
                        </Col>
                        <Col lg={2}>
                          <Typography.Text style={{ fontWeight: 600, fontSize: 14 }}>Mark Per Question</Typography.Text>
                        </Col>
                        <Col lg={1}></Col>
                      </Row>
                      {subSectionData !== undefined && subSectionData.length > 0
                        ? subSectionData?.map((subsection: any, index: any) =>
                            subsection?.section_id === item?.id && !removedIds.includes(subsection?.id) ? (
                              <Row gutter={[16, 0]} style={{ display: 'flex', alignItems: 'center', marginBottom: 12, marginTop: 12 }}>
                                <>
                                  <>
                                    <Form.List name="previous_data">
                                      {(fields, { add, remove }) => (
                                        <>
                                          <Col xs={24} lg={2}>
                                            <Form.Item
                                              name={item?.name.toLowerCase().replaceAll(' ', '_') + '_' + index + '_sub_section_name'}
                                              rules={[{ required: true, message: 'Missing Section' }]}
                                              initialValue={subsection?.name}
                                            >
                                              <Input
                                                placeholder="Name"
                                                type="small"
                                                defaultValue={subsection?.name}
                                                onChange={e => changeOldData(e.target.value, subsection.id, 'name', item?.id)}
                                              />
                                            </Form.Item>
                                          </Col>

                                          <Col xs={24} lg={3}>
                                            <Form.Item
                                              name={item?.name.toLowerCase().replaceAll(' ', '_') + '_' + index + '_subject_id'}
                                              rules={[{ required: true }]}
                                              initialValue={subsection?.subject_id}
                                            >
                                              <Select
                                                placeholder="Subject"
                                                onChange={(value: any) =>
                                                  handleSubjectChange(
                                                    value,
                                                    'edit',
                                                    subsection?.id,
                                                    'previous_data',
                                                    index,
                                                    item?.name.toLowerCase().replaceAll(' ', '_') + '_' + index,
                                                    item?.name.toLowerCase().replaceAll(' ', '_'),
                                                    item?.id
                                                  )
                                                }
                                                defaultValue={subsection?.subject_id}
                                              >
                                                {showSubjectData &&
                                                  subjectkQueryResult?.data?.data?.map((item: any) => <option value={item?.id}>{item?.name}</option>)}
                                                {/* {subjectList.length > 0 && subjectList.map((item: any) => <option value={item?.id}>{item?.name}</option>)} */}
                                              </Select>
                                            </Form.Item>
                                          </Col>
                                          <Col xs={24} lg={3}>
                                            <Form.Item
                                              name={item?.name.toLowerCase().replaceAll(' ', '_') + '_' + index + '_report_theme_id'}
                                              rules={[{ required: false }]}
                                              initialValue={subsection?.report_theme_id}
                                            >
                                              <Select
                                                placeholder="Report Theme"
                                                onChange={(value: any) =>
                                                  handleReportThemeChange(
                                                    value,
                                                    'edit',
                                                    subsection?.id,
                                                    'previous_data',
                                                    index,
                                                    item?.name.toLowerCase().replaceAll(' ', '_') + '_' + index,
                                                    item?.name.toLowerCase().replaceAll(' ', '_'),
                                                    item?.id
                                                  )
                                                }
                                                showSearch
                                                defaultValue={subsection?.report_theme_id}
                                              >
                                                {reportThemeList !== undefined &&
                                                  reportThemeList.length > 0 &&
                                                  reportThemeList?.map((theme: any) =>
                                                    selectedSubjects.length > 0 ? (
                                                      selectedSubjects.map((elem: SectionDetails, i: any) =>
                                                        elem?.section_name === item?.name.toLowerCase().replaceAll(' ', '_')
                                                          ? elem?.data?.map((details: Details) => (
                                                              <>
                                                                {details.subject_id == theme?.subject_id && details.index == subsection?.id ? (
                                                                  <>
                                                                    <option key={theme?.id} value={theme?.id}>
                                                                      {theme?.name}
                                                                    </option>
                                                                  </>
                                                                ) : null}
                                                              </>
                                                            ))
                                                          : null
                                                      )
                                                    ) : (
                                                      <option key={theme?.id} value={theme?.id}>
                                                        {theme?.name}
                                                      </option>
                                                    )
                                                  )}
                                              </Select>
                                            </Form.Item>{' '}
                                          </Col>
                                          <Col xs={24} lg={3}>
                                            <Form.Item
                                              name={item?.name.toLowerCase().replaceAll(' ', '_') + '_' + index + '_theme_id'}
                                              rules={[{ required: false }]}
                                              initialValue={subsection?.theme_id}
                                            >
                                              <Select
                                                placeholder="Theme"
                                                onChange={(value: any) =>
                                                  handleThemeChange(
                                                    value,
                                                    'edit',
                                                    subsection?.id,
                                                    'previous_data',
                                                    index,
                                                    item?.name.toLowerCase().replaceAll(' ', '_') + '_' + index,
                                                    item?.name.toLowerCase().replaceAll(' ', '_'),
                                                    item?.id
                                                  )
                                                }
                                                showSearch
                                                defaultValue={subsection?.theme_id}
                                              >
                                                {themeList !== undefined &&
                                                  themeList.length > 0 &&
                                                  themeList?.map((theme: any) =>
                                                    selectedSubjects.length > 0 ? (
                                                      selectedSubjects.map((elem: SectionDetails, i: any) =>
                                                        elem?.section_name === item?.name.toLowerCase().replaceAll(' ', '_')
                                                          ? elem?.data?.map((details: Details) => (
                                                              <>
                                                                {details.report_theme_id == theme?.report_theme_id &&
                                                                details.index == subsection?.id ? (
                                                                  <>
                                                                    <option key={theme?.id} value={theme?.id}>
                                                                      {theme?.name}
                                                                    </option>
                                                                  </>
                                                                ) : null}
                                                              </>
                                                            ))
                                                          : null
                                                      )
                                                    ) : (
                                                      <option key={theme?.id} value={theme?.id}>
                                                        {theme?.name}
                                                      </option>
                                                    )
                                                  )}
                                              </Select>
                                            </Form.Item>{' '}
                                          </Col>
                                          <Col xs={24} lg={3}>
                                            <Form.Item
                                              name={item?.name.toLowerCase().replaceAll(' ', '_') + '_' + index + '_sub_theme_id'}
                                              rules={[{ required: false }]}
                                              initialValue={subsection?.sub_theme_id}
                                            >
                                              <Select
                                                defaultValue={subsection?.sub_theme_id}
                                                placeholder="Sub Theme"
                                                onChange={value =>
                                                  handleSubThemeChange(
                                                    value,
                                                    'edit',
                                                    subsection?.id,
                                                    'previous_data',
                                                    index,
                                                    item?.name.toLowerCase().replaceAll(' ', '_') + '_' + index,
                                                    item?.name.toLowerCase().replaceAll(' ', '_')
                                                  )
                                                }
                                              >
                                                {subThemeList !== undefined &&
                                                  subThemeList.length > 0 &&
                                                  subThemeList?.map((theme: any) =>
                                                    selectedSubjects.length > 0 ? (
                                                      selectedSubjects.map((elem: SectionDetails, i: any) =>
                                                        elem?.section_name === item?.name.toLowerCase().replaceAll(' ', '_')
                                                          ? elem?.data?.map((details: Details) => (
                                                              <>
                                                                {details.theme_id == theme?.theme?.id && details.index == subsection?.id ? (
                                                                  <>
                                                                    <option key={theme?.id} value={theme?.id}>
                                                                      {theme?.name}
                                                                    </option>
                                                                  </>
                                                                ) : null}
                                                              </>
                                                            ))
                                                          : null
                                                      )
                                                    ) : (
                                                      <option key={theme?.id} value={theme?.id}>
                                                        {theme?.name}
                                                      </option>
                                                    )
                                                  )}
                                              </Select>
                                            </Form.Item>
                                          </Col>
                                          <Col xs={24} lg={3}>
                                            <Form.Item
                                              name={item?.name.toLowerCase().replaceAll(' ', '_') + '_' + index + '_topic_id'}
                                              rules={[{ required: false }]}
                                              initialValue={subsection?.topic_id}
                                            >
                                              <Select
                                                defaultValue={subsection?.topic_id}
                                                placeholder="Topic"
                                                onChange={value => changeOldData(value, subsection.id, 'topic_id', item?.id)}
                                              >
                                                {topicList !== undefined &&
                                                  topicList.length > 0 &&
                                                  topicList?.map((topic: any) =>
                                                    selectedSubjects.length > 0 ? (
                                                      selectedSubjects.map((elem: SectionDetails, i: any) =>
                                                        elem?.section_name === item?.name.toLowerCase().replaceAll(' ', '_')
                                                          ? elem?.data?.map((details: Details) => (
                                                              <>
                                                                {details.subtheme_id == topic?.sub_theme?.id && details.index == subsection?.id ? (
                                                                  <>
                                                                    <option key={topic?.id} value={topic?.id}>
                                                                      {topic?.name}
                                                                    </option>
                                                                  </>
                                                                ) : null}
                                                              </>
                                                            ))
                                                          : null
                                                      )
                                                    ) : (
                                                      <option key={topic?.id} value={topic?.id}>
                                                        {topic?.name}
                                                      </option>
                                                    )
                                                  )}
                                              </Select>
                                            </Form.Item>
                                          </Col>
                                          <Col xs={24} lg={2}>
                                            <Form.Item
                                              name={item?.name.toLowerCase().replaceAll(' ', '_') + '_' + index + '_question_type_id'}
                                              rules={[{ required: false }]}
                                              initialValue={subsection?.question_type_id}
                                            >
                                              <Select placeholder="Question Type" defaultValue={subsection?.question_type_id}>
                                                {questionTypeSelectProps?.data?.data?.map((item: any) => (
                                                  <option value={item?.id}>{item?.name}</option>
                                                ))}
                                              </Select>
                                              {/* {questionTypeSelectProps?.map((item: any) => (
                                              <option value={item?.id}>{item?.label}</option>
                                            ))} */}

                                              {/* <Select
                                              {...questionTypeSelectProps}
                                              placeholder="Question Type"
                                              defaultValue={subsection?.question_type_id}
                                            /> */}
                                            </Form.Item>
                                          </Col>
                                          <Col xs={24} lg={2}>
                                            <Form.Item
                                              name={item?.name.toLowerCase().replaceAll(' ', '_') + '_' + index + '_no_of_questions'}
                                              rules={[{ required: true, message: 'Missing No of Questions' }]}
                                              initialValue={subsection?.no_of_questions}
                                            >
                                              <Input
                                                placeholder="No of Questions"
                                                type="small"
                                                defaultValue={subsection?.no_of_questions}
                                                onChange={e => changeOldData(e.target.value, subsection.id, 'no_of_questions', item?.id)}
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col xs={24} lg={2}>
                                            <Form.Item
                                              name={item?.name.toLowerCase().replaceAll(' ', '_') + '_' + index + '_mark_per_question'}
                                              rules={[{ required: true, message: 'Missing Marks' }]}
                                              initialValue={subsection?.mark_per_question}
                                            >
                                              <Input
                                                placeholder="Mark per Question"
                                                type="small"
                                                defaultValue={subsection?.mark_per_question}
                                                onChange={e => changeOldData(e.target.value, subsection.id, 'mark_per_question', item?.id)}
                                              />
                                            </Form.Item>
                                          </Col>

                                          <Col lg={1} style={{ display: 'flex', alignItems: 'center' }}>
                                            {/* <Button
                                            onClick={() => removeData(subsection?.id)}
                                            style={{ border: 0, boxShadow: 'none', background: 'transparent' }}
                                          >
                                            {' '} */}
                                            <Icons.DeleteOutlined
                                              style={{ color: 'red' }}
                                              onClick={() => {
                                                removeData(subsection?.id)
                                                // removeSection(subsection?.section_id, subsection?.id)
                                              }}
                                            />
                                            {/* </Button> */}
                                            {/* <DeleteButton key="delete" size="small" hideText type="link" onClick={() => removeData(subsection?.id)} /> */}
                                            {/* <SaveButton key="save" size="small" hideText type="link" onClick={() => addCloneData(subsection)} /> */}
                                          </Col>
                                        </>
                                      )}
                                    </Form.List>
                                  </>
                                </>
                              </Row>
                            ) : null
                          )
                        : null}
                      {/* {subSectionList.length > 0
                        ? subSectionList?.map((elem: any, i: any) =>
                            elem?.section_id === item?.id && !removedIds.includes(elem?.id) ? (
                              <Row gutter={[16, 0]} style={{ display: 'flex', alignItems: 'center', marginBottom: 12, marginTop: 12 }}>
                                <>
                                  <>
                                    <Form.List name="new_data">
                                      {(fields, { add, remove }) => (
                                        <>
                                          <Col xs={24} lg={2}>
                                            <Form.Item
                                              name={item?.name.toLowerCase().replaceAll(' ', '_') + '_' + i + '_sub_section_name'}
                                              rules={[{ required: true, message: 'Missing Section' }]}
                                              initialValue={elem?.name}
                                            >
                                              <Input
                                                placeholder="Name"
                                                type="small"
                                                defaultValue={elem?.name}
                                                onChange={e => changeOldData(e.target.value, elem?.id, 'name', item?.id)}
                                              />
                                            </Form.Item>
                                          </Col>

                                          <Col xs={24} lg={3}>
                                            <Form.Item
                                              name={item?.name.toLowerCase().replaceAll(' ', '_') + '_' + i + '_subject_id'}
                                              rules={[{ required: true }]}
                                              initialValue={elem?.subject_id}
                                            >
                                              <Select
                                                placeholder="Subject"
                                                onChange={(value: any) =>
                                                  handleSubjectChange(
                                                    value,
                                                    'edit',
                                                    elem?.id,
                                                    'new_data',
                                                    i,
                                                    item?.name.toLowerCase().replaceAll(' ', '_') + '_' + i,
                                                    item?.name.toLowerCase().replaceAll(' ', '_'),
                                                    item?.id
                                                  )
                                                }
                                                defaultValue={elem?.subject_id}
                                              >
                                                {showSubjectData &&
                                                  subjectkQueryResult?.data?.data?.map((item: any) => <option value={item?.id}>{item?.name}</option>)}
                                              </Select>
                                            </Form.Item>
                                          </Col>
                                          {console.log('xxxxxxxxxxxxxxxxxxx', elem)}
                                          <Col xs={24} lg={3}>
                                            <Form.Item
                                              name={item?.name.toLowerCase().replaceAll(' ', '_') + '_' + i + '_report_theme_id'}
                                              rules={[{ required: false }]}
                                              initialValue={elem?.report_theme_id}
                                            >
                                              <Select
                                                placeholder="Report Theme"
                                                defaultValue={elem?.report_theme_id}
                                                onChange={(value: any) =>
                                                  handleReportThemeChange(
                                                    value,
                                                    'edit',
                                                    elem?.id,
                                                    'new_data',
                                                    i,
                                                    item?.name.toLowerCase().replaceAll(' ', '_') + '_' + i,
                                                    item?.name.toLowerCase().replaceAll(' ', '_'),
                                                    item?.id
                                                  )
                                                }
                                                showSearch
                                              >
                                                {reportThemeList !== undefined &&
                                                  reportThemeList.length > 0 &&
                                                  reportThemeList?.map((theme: any) =>
                                                    selectedSubjects.length > 0 ? (
                                                      selectedSubjects.map((data: SectionDetails, i: any) =>
                                                        data?.section_name === item?.name.toLowerCase().replaceAll(' ', '_')
                                                          ? data?.data?.map((details: Details) => (
                                                              <>
                                                                {details.subject_id == theme?.subject_id && details.index == elem?.id ? (
                                                                  <>
                                                                    <option key={theme?.id} value={theme?.id}>
                                                                      {theme?.name}
                                                                    </option>
                                                                  </>
                                                                ) : null}
                                                              </>
                                                            ))
                                                          : null
                                                      )
                                                    ) : (
                                                      <option key={theme?.id} value={theme?.id}>
                                                        {theme?.name}
                                                      </option>
                                                    )
                                                  )}
                                                {/* {reportThemeList !== undefined &&
                                                  reportThemeList.length > 0 &&
                                                  reportThemeList?.map((theme: any) =>
                                                    selectedSubjects.length > 0 ? (
                                                      selectedSubjects.map((data: any, i: any) => (
                                                        <>
                                                          {data.subject_id == theme?.subject_id &&
                                                          data.index == elem?.id &&
                                                          data?.section_name === item?.name.toLowerCase().replaceAll(' ', '_') ? (
                                                            <>
                                                              <option key={theme?.id} value={theme?.id}>
                                                                {theme?.name}
                                                              </option>
                                                            </>
                                                          ) : null}
                                                        </>
                                                      ))
                                                    ) : (
                                                      <option key={theme?.id} value={theme?.id}>
                                                        {theme?.name}
                                                      </option>
                                                    )
                                                  )} 
                                              </Select>
                                            </Form.Item>{' '}
                                          </Col>
                                          <Col xs={24} lg={3}>
                                            <Form.Item
                                              name={item?.name.toLowerCase().replaceAll(' ', '_') + '_' + i + '_theme_id'}
                                              rules={[{ required: false }]}
                                              initialValue={elem?.theme_id}
                                            >
                                              <Select
                                                placeholder="Theme"
                                                defaultValue={elem?.theme_id}
                                                onChange={(value: any) =>
                                                  handleThemeChange(
                                                    value,
                                                    'edit',
                                                    elem?.id,
                                                    'new_data',
                                                    i,
                                                    item?.name.toLowerCase().replaceAll(' ', '_') + '_' + i,
                                                    item?.name.toLowerCase().replaceAll(' ', '_'),
                                                    item?.id
                                                  )
                                                }
                                                showSearch
                                              >
                                                {themeList !== undefined &&
                                                  themeList.length > 0 &&
                                                  themeList?.map((theme: any) =>
                                                    selectedSubjects.length > 0 ? (
                                                      selectedSubjects.map((data: SectionDetails, i: any) =>
                                                        data?.section_name === item?.name.toLowerCase().replaceAll(' ', '_')
                                                          ? data?.data?.map((details: Details) => (
                                                              <>
                                                                {details.report_theme_id == theme?.report_theme_id && details.index == elem?.id ? (
                                                                  <>
                                                                    <option key={theme?.id} value={theme?.id}>
                                                                      {theme?.name}
                                                                    </option>
                                                                  </>
                                                                ) : null}
                                                              </>
                                                            ))
                                                          : null
                                                      )
                                                    ) : (
                                                      <option key={theme?.id} value={theme?.id}>
                                                        {theme?.name}
                                                      </option>
                                                    )
                                                  )}
                                                {/* {themeList !== undefined &&
                                                  themeList.length > 0 &&
                                                  themeList?.map((theme: any) =>
                                                    selectedSubjects.length > 0 ? (
                                                      selectedSubjects.map((data: any, i: any) => (
                                                        <>
                                                          {data.report_theme_id == theme?.report_theme_id &&
                                                          data.index == elem?.id &&
                                                          data?.section_name === item?.name.toLowerCase().replaceAll(' ', '_') ? (
                                                            <>
                                                              <option key={theme?.id} value={theme?.id}>
                                                                {theme?.name}
                                                              </option>
                                                            </>
                                                          ) : null}
                                                        </>
                                                      ))
                                                    ) : (
                                                      <option key={theme?.id} value={theme?.id}>
                                                        {theme?.name}
                                                      </option>
                                                    )
                                                  )} 
                                              </Select>
                                            </Form.Item>{' '}
                                          </Col>
                                          <Col xs={24} lg={3}>
                                            <Form.Item
                                              name={item?.name.toLowerCase().replaceAll(' ', '_') + '_' + i + '_sub_theme_id'}
                                              rules={[{ required: false }]}
                                              initialValue={elem?.sub_theme_id}
                                            >
                                              <Select
                                                defaultValue={elem?.sub_theme_id}
                                                placeholder="Sub Theme"
                                                onChange={value =>
                                                  handleSubThemeChange(
                                                    value,
                                                    'edit',
                                                    elem?.id,
                                                    'new_data',
                                                    i,
                                                    item?.name.toLowerCase().replaceAll(' ', '_') + '_' + i,
                                                    item?.name.toLowerCase().replaceAll(' ', '_')
                                                  )
                                                }
                                              >
                                                {subThemeList !== undefined &&
                                                  subThemeList.length > 0 &&
                                                  subThemeList?.map((theme: any) =>
                                                    selectedSubjects.length > 0 ? (
                                                      selectedSubjects.map((data: SectionDetails, i: any) =>
                                                        data?.section_name === item?.name.toLowerCase().replaceAll(' ', '_')
                                                          ? data?.data?.map((details: Details) => (
                                                              <>
                                                                {details.theme_id == theme?.theme?.id && details.index == elem?.id ? (
                                                                  <>
                                                                    <option key={theme?.id} value={theme?.id}>
                                                                      {theme?.name}
                                                                    </option>
                                                                  </>
                                                                ) : null}
                                                              </>
                                                            ))
                                                          : null
                                                      )
                                                    ) : (
                                                      <option key={theme?.id} value={theme?.id}>
                                                        {theme?.name}
                                                      </option>
                                                    )
                                                  )}
                                                {/* {subThemeList !== undefined &&
                                                  subThemeList?.length > 0 &&
                                                  subThemeList.map((subtheme: any) =>
                                                    selectedThemes.length > 0 ? (
                                                      selectedThemes.map((data: any, i: any) =>
                                                        data.theme_id === subtheme?.theme?.id &&
                                                        data.index == elem?.id &&
                                                        data?.section_name === item?.name.toLowerCase().replaceAll(' ', '_') ? (
                                                          <>
                                                            <option key={subtheme?.id} value={subtheme?.id}>
                                                              {subtheme?.name}
                                                            </option>
                                                          </>
                                                        ) : null
                                                      )
                                                    ) : (
                                                      <option key={subtheme.id} value={subtheme.id}>
                                                        {subtheme.name}
                                                      </option>
                                                    )
                                                  )} *
                                              </Select>
                                            </Form.Item>
                                          </Col>
                                          <Col xs={24} lg={3}>
                                            <Form.Item
                                              name={item?.name.toLowerCase().replaceAll(' ', '_') + '_' + i + '_topic_id'}
                                              rules={[{ required: false }]}
                                              initialValue={elem?.topic_id}
                                            >
                                              <Select
                                                defaultValue={elem?.topic_id}
                                                placeholder="Topic"
                                                onChange={value => changeOldData(value, elem.id, 'topic_id', item?.id)}
                                              >
                                                {topicList !== undefined &&
                                                  topicList.length > 0 &&
                                                  topicList?.map((topic: any) =>
                                                    selectedSubjects.length > 0 ? (
                                                      selectedSubjects.map((data: SectionDetails, i: any) =>
                                                        data?.section_name === item?.name.toLowerCase().replaceAll(' ', '_')
                                                          ? data?.data?.map((details: Details) => (
                                                              <>
                                                                {details.subtheme_id == topic?.sub_theme?.id && details.index == elem?.id ? (
                                                                  <>
                                                                    <option key={topic?.id} value={topic?.id}>
                                                                      {topic?.name}
                                                                    </option>
                                                                  </>
                                                                ) : null}
                                                              </>
                                                            ))
                                                          : null
                                                      )
                                                    ) : (
                                                      <option key={topic?.id} value={topic?.id}>
                                                        {topic?.name}
                                                      </option>
                                                    )
                                                  )}
                                                {/* {topicList !== undefined &&
                                                  topicList.length > 0 &&
                                                  topicList.map((topic: any) =>
                                                    selectedSubThemes.length > 0 ? (
                                                      selectedSubThemes.map((data: any, i: any) =>
                                                        data.sub_theme_id === topic?.sub_theme?.id &&
                                                        elem.index == data?.id &&
                                                        data?.section_name === item?.name.toLowerCase().replaceAll(' ', '_') ? (
                                                          <>
                                                            <option key={topic?.id} value={topic?.id}>
                                                              {topic?.name}
                                                            </option>
                                                          </>
                                                        ) : null
                                                      )
                                                    ) : (
                                                      <option key={topic.id} value={topic.id}>
                                                        {topic.name}
                                                      </option>
                                                    )
                                                  )} *
                                              </Select>
                                            </Form.Item>
                                          </Col>
                                          <Col xs={24} lg={2}>
                                            <Form.Item name={'_question_type_id'} rules={[{ required: false }]}>
                                              <Select placeholder="Question Type" defaultValue={elem?.question_type_id}>
                                                {questionTypeSelectProps?.data?.data?.map((item: any) =>
                                                  item?.id === elem?.question_type_id ? <option value={item?.id}>{item?.name}</option> : null
                                                )}
                                              </Select>
                                            </Form.Item>
                                          </Col>
                                          <Col xs={24} lg={2}>
                                            <Form.Item
                                              name={item?.name.toLowerCase().replaceAll(' ', '_') + '_' + i + '_no_of_questions'}
                                              rules={[{ required: true, message: 'Missing No of Questions' }]}
                                              initialValue={elem?.no_of_questions}
                                            >
                                              <Input
                                                placeholder="No of Questions"
                                                type="small"
                                                defaultValue={elem?.no_of_questions}
                                                onChange={e => changeOldData(e.target.value, elem?.id, 'no_of_questions', item?.id)}
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col xs={24} lg={2}>
                                            <Form.Item
                                              name={item?.name.toLowerCase().replaceAll(' ', '_') + '_' + i + '_mark_per_question'}
                                              rules={[{ required: true, message: 'Missing Marks' }]}
                                              initialValue={elem?.mark_per_question}
                                            >
                                              <Input
                                                placeholder="Mark per Question"
                                                type="small"
                                                defaultValue={elem?.mark_per_question}
                                                onChange={e => changeOldData(e.target.value, elem?.id, 'mark_per_question', item?.id)}
                                              />
                                            </Form.Item>
                                          </Col>

                                          <Col lg={1} style={{ display: 'flex', alignItems: 'center' }}>
                                            <Icons.DeleteOutlined
                                              style={{ color: 'red' }}
                                              onClick={() => {
                                                removeData(elem?.id)
                                                removeSection(elem?.section_id, elem?.id)
                                              }}
                                            />
                                            {/* <DeleteButton key="delete" size="small" hideText type="link" onClick={() => removeData(elem?.id)} /> */}
                      {/* <SaveButton key="save" size="small" hideText type="link" onClick={() => addCloneData(elem)} /> *
                                          </Col>
                                        </>
                                      )}
                                    </Form.List>
                                  </>
                                </>
                              </Row>
                            ) : null
                          )
                        : null} */}
                    </>
                    {tableQueryResult?.data?.data?.[0]?.sections?.map((data: any) => (
                      <>
                        <Descriptions size="small" column={3} style={{ marginTop: 20 }}>
                          <>
                            {data?.section_id === item?.id ? (
                              <>
                                <Descriptions.Item label="No of questions requested">{data?.no_of_questions}</Descriptions.Item>
                                <Descriptions.Item label="Total marks requested">{data?.marks}</Descriptions.Item>
                              </>
                            ) : null}
                          </>
                        </Descriptions>
                        {sectionTotal?.map((total: any) =>
                          data?.section_id === item?.id && total?.section_id === data?.section_id ? (
                            <>
                              {console.log('total', { total })}
                              {total?.question_count > data?.no_of_questions ? (
                                <>
                                  {' '}
                                  <Text type="danger">Limit Exceeded!!!Questions requested is {data?.no_of_questions} </Text>
                                  <br />
                                </>
                              ) : null}
                              {total?.total_mark > data?.marks ? (
                                <Text type="danger">Limit Exceeded!!!Total marks requested is {data?.marks} </Text>
                              ) : null}
                            </>
                          ) : null
                        )}
                      </>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        id={item?.name.toLowerCase().replace(' ', '_')}
                        onClick={() => addSubsection(item?.id)}
                        block
                        icon={<PlusOutlined />}
                      >
                        Add Sub Section
                      </Button>
                    </Form.Item>

                    {/* <Form.List name="sections">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <Space key={key} style={{ marginBottom: 8 }} align="baseline">
                            <Col xs={24} lg={24}>
                              <Form.Item
                                {...restField}
                                name={[name, item?.name.toLowerCase().replace(' ', "_") + '_sub_section_name']}
                                rules={[{ required: true, message: 'Missing Section' }]}
                              >
                                <Input placeholder="Name" type="small" />
                              </Form.Item>
                            </Col>

                            <Col xs={24} lg={24}>
                              <Form.Item {...restField} name={[name, item?.name.toLowerCase().replace(' ', "_") + '_subject_id']} rules={[{ required: true }]}>
                                <Select placeholder="Subject" {...subjectSelectProps} onChange={handleSubjectChange} />
                              </Form.Item>
                            </Col>
                            <Col xs={24} lg={24}>
                              <Form.Item {...restField} name={[name, item?.name.toLowerCase().replace(' ', "_") + '_theme_id']} rules={[{ required: false }]}>
                                <Select placeholder="Theme" onChange={handleThemeChange} showSearch>
                                  {themeResult?.data?.data?.map(item => (
                                    <option key={item.id} value={item.id}>
                                      {item.name}
                                    </option>
                                  ))}
                                </Select>
                              </Form.Item>  </Col>
                            <Col xs={24} lg={24}>

                              <Form.Item {...restField} name={[name, item?.name.toLowerCase().replace(' ', "_") + '_sub_theme_id']} rules={[{ required: false }]}>
                                <Select placeholder="Sub Theme" onChange={handleSubThemeChange}>
                                  {subThemeResult?.data?.data?.map(item => (
                                    <option key={item.id} value={item.id}>
                                      {item.name}
                                    </option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col xs={24} lg={24}>

                              <Form.Item {...restField} name={[name, item?.name.toLowerCase().replace(' ', "_") + '_topic_id']} rules={[{ required: false }]}>
                               
                                <Select placeholder="Topic">
                                  {topicResult?.data?.data?.map(item => (
                                    <option key={item.id} value={item.id}>
                                      {item.name}
                                    </option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Form.Item
                              {...restField}
                              name={[name, item?.name.toLowerCase().replace(' ', "_") + '_no_of_questions']}

                              rules={[{ required: true, message: 'Missing No of Questions' }]}
                            >
                              <Input placeholder="No of Questions" type="small" />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, item?.name.toLowerCase().replace(' ', "_") + '_mark_per_question']}

                              rules={[{ required: true, message: 'Missing Marks' }]}
                            >
                              <Input placeholder="Mark per Question" type="small" />
                            </Form.Item>
                            <MinusCircleOutlined onClick={() => remove(name)} />
                          </Space>
                        ))}
                        <Form.Item>
                          <Button type="dashed" id={item?.name.toLowerCase().replace(' ', "_")} onClick={() => add()} block icon={<PlusOutlined />}>
                            Add Sub Section
                          </Button>
                        </Form.Item>
                      </>
                    )}
                  </Form.List> */}
                  </Panel>
                ))}
            </Collapse>
          </Col>
        </Row>
      </Form>
      {/* Modal to update  */}

      {/* <EditSubSection modalProps={editModalProps} formProps={editFormProps} record={record} testTrackQueryResult={testTrackQueryResult} /> */}
      <CloneUpdateSubSection
        modalProps={createModalProps}
        formProps={createFormProps}
        record={record}
        testTrackQueryResult={testTrackQueryResult}
        handleOk={handleOk}
        close={createClose}
        sectionId={currentSectionId}
      />
    </Create>
  )
}
